module.exports = __webpack_public_path__ + "img/banner_wrap3.bc2acef4.png";